/** 电子签章相关接口 */
export default {
  // 新增用印申请
  insertSealApply: '/ygsjzs/sealApply/insertSealApply',
  // 审批用印申请
  approvalSealApply: '/ygsjzs/sealApply/approvalSealApply',
  // 查询用印页面链接
  updateSealApply: '/ygsjzs/sealApply/updateSealApply',
  // 物理删除用印申请
  deleteDataSealApply: '/ygsjzs/sealApply/deleteDataSealApply',
  // 新增用印文件
  insertAllSealFile: '/ygsjzs/sealApply/insertAllSealFile',
  // 查询电子章请求头
  selectqiyuesuo: '/ygsjzs/sealApply/selectqiyuesuo',
  // 查询用印申请详情
  selectSealApplyByApplyId: '/ygsjzs/sealApply/selectSealApplyByApplyId',
  // 分页查询用印申请列表
  selectSealApplyByPage: '/ygsjzs/sealApply/selectSealApplyByPage',
  // 新增文件
  addDocumentByFile: '/ygsjzs/sealApply/addDocumentByFile'
}
